import React from 'react';
import { useHeadingScale } from './typography/heading-scale';

export default function FancyTitle({
  text,
  subtitle,
  className,
  tag = 'div',
  fontSize = 'lg:text-5xl',
  marginBottom = 'mb-20',
  textAlign = 'start',
  lineHeight = 'leading-normal',
  styleOverrides = '',
  subtitleColor = 'green-dark',
}) {
  let Tag = 'div';
  try {
    const tagParse = parseInt(tag);
    if (!Number.isNaN(tagParse)) {
      Tag = `h${tagParse}`;
    } else {
      Tag = tag;
    }
  } catch (error) {
    Tag = tag;
  }

  // Non-null only inside a HeadingScaleProvider (Reference pages).
  // When set it replaces both the hardcoded base size and the fontSize prop,
  // and its marginBottom overrides the mb-20 default so headlines use mb-6.
  const headingScale = useHeadingScale();
  const scaledSize = headingScale ? headingScale.scale[Tag] : null;
  const resolvedMarginBottom = headingScale?.marginBottom || marginBottom;

  return (
    <div
      className={`${className || ''} ${textAlign || 'text-left'} ${resolvedMarginBottom}`}
    >
      <Tag
        className={`
        inline-block
        relative
        ${scaledSize || `text-3xl ${fontSize}`}
        ${lineHeight}
        font-bold
        fancy-title
        ${styleOverrides}
        w-full
      `}
        dangerouslySetInnerHTML={{ __html: text }}
      />
      {subtitle && (
        <h3
          className={`text-latori-${subtitleColor} font-monospace font-bold uppercase text-xl pt-0 lg:pt-3 ${textAlign}`}
        >
          {subtitle}
        </h3>
      )}
    </div>
  );
}
